// Internal-role checks mirroring the backend route gates (RF15).
// The permission system cannot express these: every internal user is
// granted every named permission, so role-aware rendering has to look
// at the role itself. Keep these lists in sync with
// backend/middleware/auth.js (internalBillingMiddleware /
// internalAdminManagerMiddleware).

const BILLING_ROLES = ['system_admin', 'admin', 'manager', 'accounting'];
const ADMIN_MANAGER_ROLES = ['system_admin', 'admin', 'manager'];

const userRolesOf = (user) =>
  Array.isArray(user?.roles) ? user.roles : [user?.role].filter(Boolean);

// Billing-sensitive mutations: invoices, storage agreements, customer
// fees, billing exceptions, Zoho actions.
export const hasBillingRole = (user) =>
  user?.user_type === 'internal'
  && userRolesOf(user).some((role) => BILLING_ROLES.includes(role));

// Stock-changing corrections: receipt void, adjustment, transfer.
export const hasAdminManagerRole = (user) =>
  user?.user_type === 'internal'
  && userRolesOf(user).some((role) => ADMIN_MANAGER_ROLES.includes(role));
